/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-shadow */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
import { useState, useEffect } from 'react';
// @mui
import {
  Stack, Typography, Box, Container, Grid, Card, CardHeader, IconButton,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
// components
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import MultiSelector from '../components/multi-selector/multiSelector';
import VideoPlayer from '../components/video-player/videoPlayer';
import axiosInstance from '../utils/axiosInstance';

export default function CameraRecordedStream() {
  const cameraList = useSelector((state) => state.app.cameraList);
  const [selectedCameraList, setSelectedCameraList] = useState([]);
  const [cameraWithTimelines, setCameraWithTimelines] = useState([]);
  const [cameraInRow, setCameraInRow] = useState(1);
  const [inputValue, setInputValue] = useState('');
  const location = useLocation();

  useEffect(() => {
    window.recordedStreamingCameras = selectedCameraList;
    return () => {
      window.recordedStreamingCameras = null;
    };
  }, [selectedCameraList]);

  const checkTimelines = async (camera) => {
    console.log("Checking timelines for camera:", camera.name);

    try {
      const response = await axiosInstance.get(
        `${window.location.protocol}//${camera.host}/api/v1/record/${camera.sensorId}/timelines`
      );

      const isTimelinePresent = response.data && response.data.length > 0;
      console.log(`${camera.name} Timelines:`, isTimelinePresent ? "present" : "not present");

      return isTimelinePresent;
    } catch (error) {
      console.log("Failed to fetch timelines for camera:", camera.name);
      return false;
    }
  };

  useEffect(() => {
    if (location.pathname !== '/vst/recorded-streams' && location.pathname !== '/mms/recorded-streams') {
      return;
    }
    const filterCamsWithTimelines = async () => {
      const camsWithTimelines = [];
      for (const camera of cameraList) {
        const f = await checkTimelines(camera);
        if (f) {
          camsWithTimelines.push(camera);
        }
      }

      console.log("cams with timelines", camsWithTimelines)

      setCameraWithTimelines(camsWithTimelines);
    };
    filterCamsWithTimelines();
  }, [location, cameraList]);

  const handleInputValue = (val) => {
    setInputValue(val);
  };
  const handleSelectedCameraListChange = (val) => {
    setSelectedCameraList(val);
  };

  const handleZoomOut = () => {
    setCameraInRow((prev) => (prev < 3 ? prev + 1 : prev));
  };

  const handleZoomIn = () => {
    setCameraInRow((prev) => (prev > 1 ? prev - 1 : prev));
  };

  const closeCamera = (camera) => {
    const temp = selectedCameraList.filter((item) => item.sensorId !== camera.sensorId);
    setSelectedCameraList(temp);
  };

  // Filter out selected cameras from the cameraList
  const availableCameras = cameraWithTimelines.filter(
    (camera) => !selectedCameraList.some(selectedCamera => selectedCamera.sensorId === camera.sensorId)
  );

  return (
    <div
      style={{
        display:
          location.pathname === '/vst/recorded-streams' || location.pathname === '/mms/recorded-streams'
            ? 'inline'
            : 'none',
      }}
    >
      <Helmet>
        <title> stream </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Recorded streams
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <CardHeader title="Recorded streams" subheader="Stream recorded streams" />
              <Box sx={{ p: 3 }}>
                <Stack spacing={3} sx={{ mb: 2 }}>
                  <MultiSelector
                    id="recorded-stream-selector-multi"
                    placeholder="Type to search"
                    label="Select cameras"
                    value={selectedCameraList}
                    inputValue={inputValue}
                    onInputChange={handleInputValue}
                    onChange={handleSelectedCameraListChange}
                    getOptionLabel={(option) => {
                      if (option.remoteDeviceName && option.remoteDeviceLocation) {
                        return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
                      } if (option.remoteDeviceName) {
                        return `${option.name} at ${option.remoteDeviceName}`;
                      }
                      return option.name;

                    }}
                    options={availableCameras}
                  />
                </Stack>
                <Box
                  m={1}
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="flex-end"
                  sx={{
                    display: {
                      xs: 'none', sm: 'none', md: 'none', lg: 'flex',
                    },
                  }}
                >
                  <IconButton onClick={handleZoomIn}>
                    <ZoomInIcon />
                  </IconButton>
                  <IconButton onClick={handleZoomOut}>
                    <ZoomOutIcon />
                  </IconButton>
                </Box>
              </Box>
            </Card>
          </Grid>
          {selectedCameraList.map((camera) => (
            <Grid item xs={12} sm={12} md={12 / cameraInRow} key={camera.sensorId}>
              <VideoPlayer camera={camera} cameraInRow={cameraInRow} page="recorded" closeCamera={closeCamera} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
}
